import ComponentElement from 'components/component-element';
import {createElement} from 'methods/utils';

function PhotogalleryUploaderImage(options = {}) {
    const $element = createElement(
        `<div class="Photogallery-uploader__image js-uploaderImage">
            <img>
            <div class="Photogallery-uploader__image-cross js-uploaderImageRemove"></div>
            <div class="Photogallery-uploader__image-progress js-progress"></div>
        </div>`
    );

    ComponentElement.call(this, $element, options);

    this.$img = this.$element.querySelector('img');

    // блокирование нажатий на фотки
    this.$element.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
    });

    // клик на крестик
    this.$cross = this.$element.querySelector('.js-uploaderImageRemove');
    this.$cross.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        this.remove();
    });

    this.$progress = this.$element.querySelector('.js-progress');
    this.progressValue = 0;

    this.setId(this.options.id);
    this.setSrc(this.options.src);
}

PhotogalleryUploaderImage.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(PhotogalleryUploaderImage.prototype, 'constructor', {
    value: PhotogalleryUploaderImage,
    enumerable: false,
    writable: true,
});

PhotogalleryUploaderImage.prototype.setSrc = function(src) {
    this.$img.src = this.src = src;
}

PhotogalleryUploaderImage.prototype.setId = function(id) {
    this.id = parseInt(id, 10);
}

PhotogalleryUploaderImage.prototype.getProgress = function() {
    return this.progressValue;
}

PhotogalleryUploaderImage.prototype.setProgress = function(value) {
    this.progressValue = value;

    const progressAnimation = this.$progress.animate([
        {width: `${Math.floor(value * 100)}%`, easing: 'ease-in-out'},
    ], {
        duration: 400,
        fill: 'forwards',
    });

    if (value >= 1) {
        return progressAnimation.finished.then(() => {
            this.$progress.animate([
                {opacity: 0},
            ], 400).finished.then(() => {
                this.$progress.remove();
            });
        })
    }

    return progressAnimation.finished;
}

PhotogalleryUploaderImage.prototype.remove = function() {
    this.$element.remove();
    this.emit('remove');
}

PhotogalleryUploaderImage.fromFile = function(file) {
    const image = new PhotogalleryUploaderImage();

    image.file = file;

    const fileReader = new FileReader();
    fileReader.onload = () => {
        image.setSrc(fileReader.result);
    }
    fileReader.readAsDataURL(image.file);

    return image;
}

export default PhotogalleryUploaderImage;
